export enum TableEventType {
  GlobalReloadData = 1,
  ReloadData = 2,
}